// @ts-nocheck
import React,{useState, Fragment, useEffect} from "react";
import LoginScreen from './Login';
import NewHeader from './NewHeader';
import GenerateArt from './Generate'
import SpotifyLogin from './SpotifyLogin'
import AppleMusicLogin from './AppleMusicLogin'
import {Button, Paper, Typography} from '@mui/material';
// import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import firebase from 'firebase/compat/app';
import 'firebaseui/dist/firebaseui.css'
import styled from 'styled-components'
import { UserContext } from './UserContext'

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#cfd6d8',
      contrastText: 'rgba(24,23,23,0.87)',
    },
    secondary: {
      main: '#ff9100',
    },
    background: {
      default: '#455a64',
      paper: '#cfd8dc',
    },
    divider: 'rgba(224,219,219,0.95)',
    success: {
      main: '#31e03c',
    },
  },
  typography: {
    fontFamily: 'Josefin Sans',
  },
  shape: {
    borderRadius: 16,
  },
};


let theme = createTheme(themeOptions);

const AppContainer = styled.div`
  padding: 25px;
  text-align: left;
`

const SignOutContainer = styled.div`
  position: sticky;
  padding: 10px;
  bottom: 0;
  width: 250px;
`

const SignOutButton = styled(Button)`
  && {
    margin-top: 10px;
    font-size: 10px;
  }
`

const UserInfoContainer = styled.div`
  padding-left: 5%;
  // padding-top: 5px;
  padding-bottom: 3%;
  color: black;
`

const MusicPlatformLoginContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  height: 350px;
`


const StickyContainer = styled.div`
  padding: 10px;
  top: 120px;
  right 75px;
`


const App = () => {  
  const [user, setUser] = useState(null)

  const logout = async () => {
    await firebase.auth().signOut()
    setUser(null)
  }

  const logoutAppleMusic = async () => {
    const options  =  {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + user.firebase_token},
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/logout/apple`, options)
      await response.json()
      if (response.ok){
        console.log("Removed apple token from database")
        const new_user = {...user, signed_into_apple_music: false}
        setUser(new_user)
      }
      else {
        console.log(">:( Failed to remove apple token from database")
      }
    } catch (e) {
      console.log("Could not reach backend", e)
    }
  }

  const logoutSpotify = async () => {
    const options  =  {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + user.firebase_token},
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/logout/spotify`, options)
      await response.json()
      if (response.ok){
        console.log("Removed spotify token from database")
        const new_user = {...user, signed_into_spotify: false}
        setUser(new_user)
      }
      else {
        console.log(">:( Failed to remove spotify token from database")
      }
    } catch (e) {
      console.log("Could not reach backend", e)
    }
  }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/`)
  }, [])


  console.log("User: ", user)
  return (
    <ThemeProvider theme={theme}>
      <UserContext.Provider value={{user, setUser}}>
        <CssBaseline/>
        <NewHeader/>
        <AppContainer>
          <Paper elevation={3}>
            <Typography variant="h5" align="center" padding="30px">Dallpaper Testing</Typography>
            {!user 
              ? <LoginScreen />
              : <Fragment>
                  <UserInfoContainer>
                    <Typography>Welcome {user.email}</Typography>
                    <br/>
                    <Typography>User ID: {user.firebase_id}</Typography>
                    <Typography>Signed into Spotify: {user.signed_into_spotify ? "true" : "false" }</Typography>
                    <Typography>Signed into Apple Music: {user.signed_into_apple_music ? "true" : "false" }</Typography>
                  </UserInfoContainer>
                  {(user.signed_into_spotify || user.signed_into_apple_music)
                    ? <Fragment>
                        <StickyContainer>
                          {!user.signed_into_spotify && <SpotifyLogin />}
                          {!user.signed_into_apple_music && <AppleMusicLogin />}
                        </StickyContainer>
                        <GenerateArt />
                      </Fragment>
                    : <MusicPlatformLoginContainer>
                        <SpotifyLogin />
                        <AppleMusicLogin />
                      </MusicPlatformLoginContainer>
                  }
                  <SignOutContainer>
                    {user.signed_into_spotify &&
                      <SignOutButton
                        size="small"
                        variant="contained"
                        color="success"
                        endIcon={<LogoutIcon />}
                        onClick={logoutSpotify}
                      >
                        Unlink Spotify
                      </SignOutButton>
                    }
                    {user.signed_into_apple_music &&
                      <SignOutButton
                        size="small"
                        variant="contained"
                        color="info"
                        endIcon={<LogoutIcon />}
                        onClick={logoutAppleMusic}
                      >
                        Unlink Apple Music
                      </SignOutButton>
                    }
                    <SignOutButton
                      size="small"
                      variant="contained"
                      color="error"
                      endIcon={<LogoutIcon />}
                      onClick={logout}
                    >
                      Sign Out of Dallpaper
                    </SignOutButton>
                  </SignOutContainer>
                </Fragment>
            }
          </Paper>
        </AppContainer>
      </UserContext.Provider>
    </ThemeProvider>
  );
};


export default App;